/* eslint-disable */

<template>
  <span class="counter__wrapper">
    <span
      v-for="(char, index) in getValString"
      :key="index"
      :class="{ counter__animate: char != '.' }"
    >
      {{ char }}
    </span>
  </span>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CSSPlugin } from 'gsap/CSSPlugin'

gsap.registerPlugin(ScrollTrigger, CSSPlugin)

export default {
  props: {
    value: {
      type: String,
    },
  },
  computed: {
    getValString: function() {
      return String(this.value)
    },
  },
  methods: {
    scrollIn() {
      gsap.utils.toArray('.counter__animate').forEach((num, index) => {
        const numSlide = gsap.timeline({
          scrollTrigger: {
            trigger: num,
            // toggleActions: 'restart none none reset',
          },
        })

        numSlide.to(num, {
          ease: 'expo.out',
          duration: 0.75,
          delay: 0.15 * (index + 1),
          y: 0,
          opacity: 1,
        })
      })
    },
  },
  mounted: function() {
    this.scrollIn()
  },
}
</script>

<style lang="scss" scoped>
.counter__wrapper {
  position: relative;
  overflow-y: hidden;
  > span {
    display: inline-block;

    &.counter__animate {
      transform: translateY(1em);
      opacity: 0;
    }
  }
}
</style>
